const extensionContentTypePairs = [
  { extension: '.pdf', type: 'application/pdf' },
  { extension: '.docx', type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
  { extension: '.doc', type: 'application/msword' },
  { extension: '.xlsx', type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { extension: '.png', type: 'image/png' },
  { extension: '.jpg', type: 'image/jpeg' },
];

export function getExtension(contentType: string): string {
  return extensionContentTypePairs.find((pair) => pair.type === contentType)?.extension ?? '.pdf';
}

export function getFullFileName(documentTitle: string, contentType: string): string {
  let newTitle = sanitizeFileName(documentTitle) ?? 'document_' + new Date().getTime().toString();
  newTitle = newTitle.split('.')[0] ?? newTitle;
  return newTitle.replace(/ /g, '_') + getExtension(contentType);
}

export function attachTimestampToFileName(documentTitle: string, contentType: string): string {
  const defaultName = 'document_' + new Date().getTime().toString() + getExtension(contentType);
  if (!documentTitle) {
    return defaultName;
  }
  const parts = documentTitle.split('.');
  if (parts.length !== 2) {
    return defaultName;
  }
  return parts[0] + new Date().getTime().toString() + getExtension(contentType);
}

export function sanitizeFileName(name: string): string {
  // Keep letters/numbers/._- and replace the rest
  return name.replace(/[^a-zA-Z0-9._-]/g, '_');
}
